import type { Session } from "../models.js";

// Token storage. localStorage fallback (third-party cookie blocking). 04-web §4.
const KEY = "shortdrama.session";

export function saveSession(s: Session): void {
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function loadSession(): Session | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Session;
  } catch {
    return null;
  }
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
}

export function isAuthenticated(): boolean {
  return loadSession() !== null;
}
